import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

import { IVideoVerificationConfig } from './IVideoVerificationConfig';
import { VideogularComponent } from './videogular/Videogular.Component';

@Component({
	selector: 'vb-overlay-video-verification',
	template: `
		@if (!config.isVerified && !isOverlayHidden) {
		<div class="warning">
			<div class="trueViewContainer">
				<span class="vb-icon vb-icon-trueview"></span>
				<h4>{{ translations.trueView }}</h4>
			</div>
			<i>{{ translations.notVerified }}</i>
			<button (click)="onPlayClick()">{{ translations.watchAnyway }}</button>
		</div>
		} @else if (config.isVerified){
		<div class="verified" [ngClass]="isControlsDisplayed ? 'showAnimation' : 'hideAnimation'">
			<div class="verifiedContainer">
				<span class="vb-icon vb-icon-trueview"></span>
				<div>
					<h2>{{ config.accountName }}</h2>
					<span>{{ translations.trueViewVerified }}</span>
				</div>
			</div>
		</div>
		}
	`,
	standalone: false,
	styleUrls: ['./VbOverlayVideoVerification.Component.ng.less']
})
export class VbOverlayVideoVerificationComponent implements OnChanges {
	@Input() public config: IVideoVerificationConfig;
	@Input() public isControlsDisplayed: boolean;
	@Input() public translations: any;

	public isOverlayHidden: boolean = false;

	constructor(
		private vgApi: VideogularComponent,
	) {}

	public ngOnChanges(changes: SimpleChanges): void {
		if (changes.config) {
			this.isOverlayHidden = false;
		}
	}
	public onPlayClick(): void {
		this.vgApi.play();
		this.isOverlayHidden = true;
	}
}
